module.exports = __webpack_public_path__ + "static/media/question.36a356e6.svg";